<template>
  <VFab
    v-if="isMounted"
    id="customer-tools"
    role="button"
    tabindex="0"
    :aria-label="
      open
        ? 'Schließe die Seiteneinstellungen'
        : 'Öffne die Seiteneinstellungen'
    "
    style="bottom: 110px; left: -0.5rem"
    app
    location="bottom right"
    :color="open ? 'soft-soil' : 'light-soil'"
    size="50"
    icon="custom:accessibility"
  >
    <VBtn
      size="50"
      :color="open ? 'soft-soil' : 'light-soil'"
      icon
      :aria-label="open ? 'Symbol zum Schließen' : 'Symbol für Einstellungen'"
    >
      <VIcon> {{ open ? 'custom:close' : 'custom:settings' }} </VIcon>
    </VBtn>

    <VSpeedDial
      :location="smAndDown ? 'left center' : 'top center'"
      v-model="open"
      activator="parent"
    >
      <slot />
    </VSpeedDial>
  </VFab>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useDisplay } from 'vuetify'

const open = ref(false)
const { smAndDown } = useDisplay()

// Client-only: VFab measures the layout and VSpeedDial mounts overlay
// machinery, so its server markup never matches the client's first render
// (hydration children/style mismatches). A floating settings button has no
// SEO value — render it after mount instead (VIP-12038).
const isMounted = ref(false)
onMounted(() => {
  isMounted.value = true
})
</script>

<style scoped>
#customer-tools {
  opacity: 0.9;
}
</style>
